import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/gaushala/vrindavan-gaushala";

export const Route = createFileRoute("/admin/_gaushala/vrindavan-gaushala")({
  component: Page,
});
